import styled from 'styled-components';

import { Text } from '@calm-web/design-system';

export const ContentDisplayWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ContentImageWrapper = styled.div`
	margin-top: 20px;

	img {
		border-radius: 20px;
	}
`;

export const ContentTypeNarratorNameContainer = styled(Text)`
	margin-top: 4px;
`;

export const ContentTitle = styled(Text)`
	margin-top: 8px;
`;
